/* eslint-disable complexity */
/* eslint-disable sonarjs/cognitive-complexity */
// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';
import { BUTTON_VARIATION } from './Button.constants';

const darkLinkCategory = 'category-links-dark';

const getShape = (props) => {
  const {
    theme: { brandSpecificStyles },
    noCurve,
    noCurveMobile,
  } = props;

  const gymSPCRadius = 'border-radius : 6px;';

  if (noCurveMobile) {
    return props.spc ? gymSPCRadius : brandSpecificStyles.BUTTON_NO_CURVE_MOBILE_CSS;
  }
  if (!noCurve) {
    return props.spc ? gymSPCRadius : brandSpecificStyles.BUTTON_CURVE_CSS;
  }
  return ``;
};

const checkHover = (props) => {
  return props.nohover
    ? ''
    : `&:hover {
    border-bottom: 2px solid
       ${props.theme.brandSpecificStyles.BUTTON_HOVER_BORDER_BOTTOM_COLOR};
     padding-bottom: ${!props.nohover ? '4px' : ''};
     text-decoration: none;
     border-radius: 0;
   }`;
};

const showBorderRadiusStyle = (props) =>
  props.isHpNewDesignCTAEnabled ? `border-radius: ${props.theme.spacing.ELEM_SPACING.XS_6}` : `0`;

const ButtonStyles = css`
  border: none;
  ${(props) =>
    props.theme.isGymboree
      ? ``
      : `@media ${props.theme.mediaQuery.medium} {
    border-radius: ${
      props.showBorderRadiusStyle || props.isHpNewDesignCTAEnabled
        ? props.theme.spacing.ELEM_SPACING.XS_6
        : `0`
    };
  }
  @media ${props.theme.mediaQuery.smallOnly} {
    ${
      props.showBorderRadiusStyle && props.ctaBorderStyle
        ? props.ctaBorderStyle
        : showBorderRadiusStyle(props)
    };
  }`}

  background: none;
  position: relative;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.disabled ? props.theme.opacity.opacity.medium : '1')};
  text-transform: uppercase;
  min-height: 42px;
  letter-spacing: 0.93px;
  font-size: ${(props) => props.theme.typography.fontSizes.fs13};
  color: ${(props) => props.theme.colorPalette.gray['900']};
  ${(props) =>
    !props.link
      ? `@media ${props.theme.mediaQuery.large} {
    letter-spacing: 1px;
    }`
      : ''}
  ${(props) =>
    props.buttonVariation === 'fixed-width'
      ? `
      min-width: 40px;
      background: ${props.theme.colors.BUTTON[props.fill || 'WHITE'].NORMAL};
      color: ${props.theme.colors.BUTTON[props.fill || 'WHITE'].TEXT};
      font-family: ${props.theme.typography.fonts.secondary};
      font-weight: ${props.theme.typography.fontWeights.extrabold};
      border: 1px solid ${props.theme.colors.BUTTON[props.fill || 'WHITE'].BORDER};
      border-color: ${props.theme.colors.BUTTON[props.fill || 'WHITE'].BORDER_VAL};
      background-size:${props.theme.colors.BUTTON[props.fill || 'WHITE'].BG_SIZE};
      background-image:${props.theme.colors.BUTTON[props.fill || 'WHITE'].BG_IMAGE};
      padding: 11px 20px;
      width: 100%;
      &:hover, &:focus {
        border: solid 1px ${
          // eslint-disable-next-line no-nested-ternary
          props.fill === 'RED'
            ? props.theme.colorPalette.red[500]
            : props.fill === 'SNJ_PRIMARY' ||
              props.fill === 'SNJ_SECONDARY' ||
              props.fill === 'SNJ_HP_PRIMARY' ||
              props.fill === 'SNJ_HP_SECONDARY' ||
              props.fill === 'SNJ_HP_TERTIARY'
            ? ''
            : props.theme.colorPalette.gray[600]
        };
        background-color: ${
          props.fill === 'SNJ_PRIMARY' || props.fill === 'SNJ_SECONDARY'
            ? ''
            : props.theme.colors.BUTTON[props.fill || 'WHITE'].HOVER
        };
        color:${props.theme.colors.BUTTON[props.fill || 'WHITE'].HOVER_TEXT};
        border:${props.theme.colors.BUTTON[props.fill || 'WHITE'].HOVER_BORDER};
        border:solid 1px ${props.theme.colors.BUTTON[props.fill || 'WHITE'].HOVER_TRANS};
        background-image:${props.fill === 'SNJ_HP_TERTIARY' && 'none'};
        background-position: ${
          props.fill === 'SNJ_HP_TERTIARY'
            ? props.theme.colors.BUTTON[props.fill || 'WHITE'].HOVER_BG_POSITION
            : props.theme.colors.BUTTON[props.fill || 'WHITE'].BG_POSITION
        };

        transition: ${props.theme.colors.BUTTON[props.fill || 'WHITE'].TRANSITION};
        ${
          (props.fill === 'SNJ_HP_SECONDARY' || props.fill === 'SNJ_SECONDARY') &&
          `background-size:${props.theme.colors.BUTTON[props.fill || 'WHITE'].HOVER_BG_SIZE};`
        }

      }
      &:disabled:hover{
        background: ${props.theme.colors.BUTTON[props.fill || 'WHITE'].NORMAL};
        color: ${props.theme.colors.BUTTON[props.fill || 'WHITE'].TEXT};
        border: 1px solid ${props.theme.colors.BUTTON[props.fill || 'WHITE'].BORDER};
        border-color: ${props.theme.colors.BUTTON[props.fill || 'WHITE'].BORDER_VAL};
      }
      ${
        props.fill === 'SNJ_HP_PRIMARY'
          ? `span {
     display: block;
     }
    &::before,&::after {
    content: '';
    width: 0;
    height: 1px;
    position: absolute;
   }
   &:disabled{pointer-events:none}
  }
  span::before,span::after {
    content: '';
    width: 1px;
    height: 0;
    position: absolute;
    transition: all 0.2s linear;
    background: ${props.theme.colors.BUTTON.SNJ_HP_PRIMARY.ALT_FOCUS};
  }
  &::before {
    right: 0;
    top: 0;
    transition-delay: 0.2s;
   }
  &::after {
    left: 0;
    bottom: 0;
    transition-delay: 0.6s;
  }
  &:hover::before,&:hover::after {
    width: 100%;
  }
  span::after {
    transition-delay: 0.4s;
    right: 0;
    bottom: 0;
  }
  span::before {
    transition-delay: 0s;
    left: 0;
    top: 0;
  }
  &:hover span::before, &:hover span::after {
    height: 100%;
  }
  &:hover::after {
    transition-delay: 0s;
  }
  &:hover span::after {
    transition-delay: 0.2s;
  }
  &:hover::before {
    transition-delay: 0.4s;
  }
  &:hover span::before {
    transition-delay: 0.6s;
  }
`
          : ''
      };
    `
      : ''};
  ${(props) =>
    props.buttonVariation === 'variable-width'
      ? `
      min-width: 64px;
      background: ${props.theme.colors.BUTTON[props.fill || 'WHITE'].NORMAL};
      color: ${props.theme.colors.BUTTON[props.fill || 'WHITE'].TEXT};
      font-family: ${props.theme.fonts.secondaryFontFamily};
      font-weight: ${props.theme.fonts.fontWeight.black};
      border: 1px solid ${props.theme.colors.BUTTON[props.fill || 'WHITE'].BORDER};
      transition: ${props.theme.colors.BUTTON[props.fill || 'WHITE'].TRANSITION};
      padding: 11px 32px;
      background-size:${props.theme.colors.BUTTON[props.fill || 'WHITE'].BG_SIZE};
      background-image:${props.theme.colors.BUTTON[props.fill || 'WHITE'].BG_IMAGE};
      &:hover, &:focus {
        border: solid 1px ${
          props.fill === 'RED'
            ? props.theme.colorPalette.red[500]
            : props.theme.colorPalette.gray[600]
        };
        background-color: ${
          props.fill === 'SNJ_SECONDARY' || props.fill === 'SNJ_PRIMARY'
            ? ''
            : props.theme.colors.BUTTON[props.fill || 'WHITE'].HOVER
        };

        color:${props.theme.colors.BUTTON[props.fill || 'WHITE'].HOVER_TEXT};
        border:${props.theme.colors.BUTTON[props.fill || 'WHITE'].HOVER_BORDER};
        border:solid 1px ${props.theme.colors.BUTTON[props.fill || 'WHITE'].HOVER_TRANS};
        background-position:${props.theme.colors.BUTTON[props.fill || 'WHITE'].BG_POSITION};
        transition: ${props.theme.colors.BUTTON[props.fill || 'WHITE'].TRANSITION};
      }
      &:disabled:hover{
        background: ${props.theme.colors.BUTTON[props.fill || 'WHITE'].NORMAL};
        color: ${props.theme.colors.BUTTON[props.fill || 'WHITE'].TEXT};
        border: 1px solid ${props.theme.colors.BUTTON[props.fill || 'WHITE'].BORDER};
        border-color: ${props.theme.colors.BUTTON[props.fill || 'WHITE'].BORDER_VAL};
      }
    `
      : ''};

  ${(props) =>
    props.buttonVariation === 'category-links-light'
      ? `
      min-height: auto;
      color: ${props.theme.colorPalette.text.primary};
      font-family: ${props.theme.typography.fonts.secondary};
      font-size: ${props.theme.typography.fontSizes.fs14};
      font-weight: ${props.theme.typography.fontWeights.regular};
      border-bottom: 2px solid ${props.theme.colorPalette.primary.main};
      margin-right: 16px;
      padding-bottom: 3px;
    `
      : ''};

  ${(props) =>
    props.buttonVariation === darkLinkCategory
      ? `
      min-height: auto;
      color: ${props.theme.colorPalette.white};
      font-family: ${props.theme.typography.fonts.secondary};
      font-size: ${props.theme.typography.fontSizes.fs14};
      font-weight: ${props.theme.typography.fontWeights.regular};
      border-bottom: 2px solid ${props.theme.colorPalette.text.hint};
      padding-bottom: 3px;
    `
      : ''};

  &:focus {
    background: ${(props) => props.theme.colors.BUTTON[props.fill || 'WHITE'].FOCUS};
  }
  &:hover:not[disabled] {
    background: ${(props) => props.theme.colors.BUTTON[props.fill || 'WHITE'].HOVER};
  }

  ${(props) =>
    props.buttonVariation === 'category-links-light' || props.buttonVariation === darkLinkCategory
      ? `
      &:hover, &:focus {
        background: none;
        font-weight: ${props.theme.typography.fontWeights.semibold}
        border-color: ${props.theme.colorPalette.orange[800]};
      }
      &:hover, &:focus {
        background: none;
        font-weight: ${props.theme.typography.fontWeights.semibold}
        border-color: ${props.theme.colorPalette.orange[800]};
      }

      /* fixes button flickering on the hover because for font-weight */
      ::after {
        font-family: ${props.theme.typography.fonts.secondary};
        font-weight: ${props.theme.typography.fontWeights.semibold}
        font-size: ${props.theme.typography.fontSizes.fs14};
        display: block;
        content: attr(data-category-link-label);
        height: 0;
        overflow: hidden;
        visibility: hidden;
      }

      @media ${props.theme.mediaQuery.large} {
      font-size: ${props.theme.typography.fontSizes.fs20};
      ::after {
          font-size: ${props.theme.typography.fontSizes.fs20};
        }
      }
    `
      : ''};

  ${(props) =>
    props.fullWidth
      ? `
      width: 100% ;
    `
      : ''};

  ${(props) =>
    props.customStyle === 'shadow-button'
      ? `
      background: ${props.theme.colors.PRIMARY.PALEGRAY};
      border-radius: 10px;
      padding: 4px 0;

      border: 2px solid ${props.theme.colors.PRIMARY.LIGHTGRAY};
      box-shadow: 4px 4px white inset, 6px 6px ${props.theme.colors.PRIMARY.PALEGRAY};
      width: calc(100% - 6px);
      &:hover, &:focus, &:hover:not([disabled]) {
        background: ${props.theme.brandSpecificStyles.BUTTON_SHADOW_PRIMARY_COLOR};
        box-shadow: 4px 4px white inset, 6px 6px ${props.theme.brandSpecificStyles.BUTTON_SHADOW_SECONDARY_COLOR};
        border: 2px solid ${props.theme.colors.PRIMARY.GRAY};
      }
      @media ${props.theme.mediaQuery.large} {
        padding: 11px 0;
        box-shadow: 10px 10px white inset, 12px 12px ${props.theme.colors.PRIMARY.PALEGRAY};
        width: calc(100% - 12px);
        &:hover, &:focus, &:hover:not([disabled]) {
          box-shadow: 10px 10px white inset, 12px 12px ${props.theme.brandSpecificStyles.BUTTON_SHADOW_PRIMARY_COLOR};
        }
      }
    `
      : ''};

  ${(props) =>
    props.buttonVariation === 'mini-nav'
      ? `
        color: ${props.theme.colorPalette.gray['900']};
        padding: 0;
        font-family: ${props.theme.fonts.secondaryFontFamily};
        font-size: ${props.theme.typography.fontSizes.fs14};
        font-weight: ${
          props.active
            ? props.theme.typography.fontWeights.semibold
            : props.theme.typography.fontWeights.normal
        };
        border-bottom: 2px solid ${
          props.active ? props.theme.colorPalette.primary.main : 'transparent'
        };
        letter-spacing: normal;
        padding: 0 5px;
        min-height: 24px;

        &:hover, &:focus, &:active {
          background-color: transparent;
          outline-width: 0;
        }

        @media ${props.theme.mediaQuery.large} {
          font-size: ${props.theme.typography.fontSizes.fs20};
          font-weight: ${
            props.active
              ? props.theme.typography.fontWeights.semibold
              : props.theme.typography.fontWeights.normal
          };
        }
        color: ${
          props.isTabbedCarouselEnabled && props.active
            ? props.theme.brandSpecificStyles.BUTTON_HOVER_BORDER_BOTTOM_COLOR
            : props.theme.colorPalette.gray['900']
        };
      `
      : ''}

  @media ${(props) => props.theme.mediaQuery.large} {
    ${(props) =>
      props.buttonVariation === 'fixed-width'
        ? `
        padding: ${props.spc ? '12' : '15'}px 20px;
        font-size: ${props.theme.typography.fontSizes.fs14};
        `
        : ''};
    ${(props) =>
      props.buttonVariation === 'variable-width'
        ? `padding: 15px 32px;font-size: ${props.theme.typography.fontSizes.fs14};`
        : ''};
  }
  ${(props) =>
    props.buttonVariation !== 'mini-nav' && props.buttonVariation !== darkLinkCategory
      ? getShape(props)
      : ``}

  ${(props) =>
    props.link || props.smallLink
      ? `
        min-height: auto;
        font-family: ${props.theme.typography.fonts.secondary};
        font-size: ${
          props.smallLink
            ? props.theme.fonts.fontSize.body.large.primary
            : props.theme.fonts.fontSize.body.large.secondary
        }px;
        letter-spacing: ${props.theme.fonts.letterSpacing.normal};
        border: 0;
        padding: 0;
        text-transform: none;
        text-decoration: ${props.underline ? 'underline' : 'none'}
      ${checkHover}
      &:focus {
        background: none;
      }
      @media ${props.theme.mediaQuery.large} {
        font-size: ${
          props.smallLink
            ? props.theme.fonts.fontSize.body.large.primary
            : props.theme.fonts.fontSize.button.size
        }px;
      }
  `
      : ``}
      ${(props) =>
    props.fill === 'BLUE'
      ? `background: ${props.theme.colorPalette.blue.C900}; border: 1px solid ${props.theme.colorPalette.blue.C900};
        &:disabled:hover {
          background: ${props.theme.colorPalette.blue.C900};
          border-color: ${props.theme.colorPalette.blue.C900};
        }
       `
      : ''};
  ${(props) =>
    props.buttonVariation === BUTTON_VARIATION.successButton
      ? `
          &, &:hover, &:focus {
            border: 1px solid ${props.theme.colorPalette.green[500]};
            min-width: 40px;
            background: ${props.theme.colors.BUTTON.WHITE.NORMAL};
            color: ${props.theme.colors.PRIMARY.DARK};
            font-family: ${props.theme.typography.fonts.secondary};
            font-weight: ${props.theme.typography.fontWeights.extrabold};
            width: 100%;
            padding: 0;
            opacity: 1;
            @media ${props.theme.mediaQuery.large} {
              padding: 10px;
            }
          }`
      : ''};
  ${(props) => (props.inheritedStyles ? props.inheritedStyles : '')};

  ${(props) => (props.loading ? 'color: transparent;' : '')};
  ${(props) => props.overrideStyle || ''}
  ${(props) => (props.borderRadius ? `border-radius: ${props.borderRadius}px;` : '')};
  ${(props) => props.overrideStyle || ''}
`;

export default ButtonStyles;
